/**
 * 调试工具
 * 用于诊断权限检查问题
 */
/**
 * 权限检查调试器
 */
export class PermissionDebugger {
    /**
     * 记录权限检查过程
     */
    static log(user, requiredPermissions, result, steps) {
        const debugInfo = {
            timestamp: new Date().toISOString(),
            user: {
                id: user?.id,
                account: user?.account,
                permissions: user?.permissions,
                isSuperAdmin: user?.isSuperAdmin,
                is_super_admin: user?.is_super_admin
            },
            requiredPermissions,
            result,
            steps
        };
        this.logs.push(debugInfo);
        // 在开发环境下输出到控制台
        if (process.env.NODE_ENV === 'development') {
            console.group(`[PermissionDebugger] ${result ? '✅' : '❌'} 权限检查`);
            console.log('用户信息:', debugInfo.user);
            console.log('所需权限:', debugInfo.requiredPermissions);
            console.log('检查步骤:', debugInfo.steps);
            console.log('结果:', result);
            console.groupEnd();
        }
    }
    /**
     * 获取所有日志
     */
    static getLogs() {
        return [...this.logs];
    }
    /**
     * 清除日志
     */
    static clearLogs() {
        this.logs = [];
    }
    /**
     * 获取最新的日志
     */
    static getLatestLog() {
        return this.logs.length > 0 ? this.logs[this.logs.length - 1] : null;
    }
    /**
     * 输出调试信息到页面
     */
    static renderDebugInfo() {
        if (typeof window === 'undefined')
            return null;
        const latestLog = this.getLatestLog();
        if (!latestLog)
            return null;
        return {
            user: latestLog.user,
            requiredPermissions: latestLog.requiredPermissions,
            result: latestLog.result,
            steps: latestLog.steps,
            timestamp: latestLog.timestamp
        };
    }
}
PermissionDebugger.logs = [];
/**
 * 简化的权限检查函数（带调试）
 */
export function debugCheckPermissions(user, requiredPermissions) {
    const steps = [];
    try {
        steps.push('开始权限检查');
        if (!user) {
            steps.push('❌ 用户不存在');
            PermissionDebugger.log(user, requiredPermissions, false, steps);
            return false;
        }
        steps.push(`✅ 用户存在: ${user.account || user.admin_name || 'unknown'}`);
        if (!requiredPermissions || requiredPermissions.length === 0) {
            steps.push('✅ 无需权限验证');
            PermissionDebugger.log(user, requiredPermissions, true, steps);
            return true;
        }
        const userPermissions = user.permissions || [];
        steps.push(`📋 用户权限列表: [${userPermissions.join(', ')}]`);
        steps.push(`📋 所需权限列表: [${requiredPermissions.join(', ')}]`);
        // 1. 检查全局通配符权限
        if (userPermissions.includes('*')) {
            steps.push('✅ 用户拥有全局通配符权限');
            PermissionDebugger.log(user, requiredPermissions, true, steps);
            return true;
        }
        // 2. 检查具体权限匹配
        const hasPermission = requiredPermissions.some((permission) => {
            // 精确匹配
            if (userPermissions.includes(permission)) {
                steps.push(`✅ 精确匹配权限: ${permission}`);
                return true;
            }
            // 服务通配符匹配
            const servicePrefix = permission.split(':')[0];
            const serviceWildcard = `${servicePrefix}:*`;
            if (userPermissions.includes(serviceWildcard)) {
                steps.push(`✅ 服务通配符匹配: ${serviceWildcard} 匹配 ${permission}`);
                return true;
            }
            // 功能通配符匹配
            const parts = permission.split(':');
            if (parts.length >= 3) {
                const functionPrefix = parts.slice(0, -1).join(':');
                const functionWildcard = `${functionPrefix}:*`;
                if (userPermissions.includes(functionWildcard)) {
                    steps.push(`✅ 功能通配符匹配: ${functionWildcard} 匹配 ${permission}`);
                    return true;
                }
            }
            steps.push(`❌ 权限不匹配: ${permission}`);
            return false;
        });
        steps.push(`🎯 最终结果: ${hasPermission ? '✅ 通过' : '❌ 拒绝'}`);
        PermissionDebugger.log(user, requiredPermissions, hasPermission, steps);
        return hasPermission;
    }
    catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        steps.push(`❌ 权限检查出错: ${errorMessage}`);
        PermissionDebugger.log(user, requiredPermissions, false, steps);
        return false;
    }
}
/**
 * 在浏览器控制台中暴露调试工具
 */
export function exposeDebugTools() {
    if (typeof window !== 'undefined') {
        window.PermissionDebugger = PermissionDebugger;
        window.debugCheckPermissions = debugCheckPermissions;
        console.log('🔧 权限调试工具已暴露到 window.PermissionDebugger 和 window.debugCheckPermissions');
    }
}
